import { render, staticRenderFns } from "./mydialog.vue?vue&type=template&id=564c6789"
import script from "./mydialog.vue?vue&type=script&lang=js"
export * from "./mydialog.vue?vue&type=script&lang=js"
import style0 from "./mydialog.vue?vue&type=style&index=0&id=564c6789&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports